import { Injectable } from "@angular/core";
import { databases, ID } from "../config/appwrite";
import { environment } from "../../../environments/environment";
import { Query } from "appwrite";
import { Convenio } from "../models";

@Injectable({
  providedIn: "root",
})
export class CitasPagosService {
  private collectionId = "citas_pagos";
  private DATABASE_NAME = environment.databaseName;

  constructor() { }

  /**
   *getData
   * @returns
   */
  getData() {
    return databases.listDocuments(this.DATABASE_NAME, this.collectionId);
  }

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument(data: any) {
    return databases.createDocument(
      this.DATABASE_NAME,
      this.collectionId,
      ID.unique(),
      data
    );
  }

  getDocument(idDocument: string) {
    return databases.getDocument(
      this.DATABASE_NAME,
      this.collectionId,
      idDocument
    );
  }

  /**
   * @getDocuments()
   * @param idEspecialista
   * @returns
   */
  getDataByPaciente(idEmpresa: string): Promise<Convenio[]> {
    return databases
      .listDocuments<Convenio>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("idEmpresa", [idEmpresa]),
      ])
      .then((response) => response.documents);
  }

  /**
   * @getDocuments()
   * @param idEspecialista
   * @returns
   */
  getDataPendiente(citas): Promise<Convenio[]> {
    console.log(citas);
    return databases
      .listDocuments<Convenio>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("IdEstadoPago", "pendiente"),
        Query.equal("idCita", citas.map(cita => cita.$id)),
      ])
      .then((response) => response.documents);
  }

  /**
   * @getDocuments()
   * @param idEspecialista
   * @returns
   */
  getDataByCita(idCita): Promise<Convenio[]> {
    return databases
      .listDocuments<Convenio>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("idCita", idCita),
      ])
      .then((response) => response.documents);
  }

  
}
